// ============================================================================
// Tabs — segmented control / pill tab strip.
//
// Generic primitive: pass `tabs` as either an array of strings (key === label)
// or an array of `{ key, label }`, plus the active key and a setter. Used by
// Trading Open/History, modal Overview/Chart/Technicals, etc.
// ============================================================================

export default function Tabs({ tabs, active, onChange, ariaLabel }) {
  return (
    <div
      role="tablist"
      aria-label={ariaLabel}
      style={{
        display: 'inline-flex',
        gap: 3,
        padding: 3,
        background: 'var(--bg-surface)',
        border: '1px solid var(--border-subtle)',
        borderRadius: 'var(--r-md)',
      }}
    >
      {tabs.map((t) => {
        const key = typeof t === 'object' ? t.key : t;
        const label = typeof t === 'object' ? t.label : t;
        const on = active === key;
        return (
          <button
            key={key}
            role="tab"
            aria-selected={on}
            onClick={() => onChange(key)}
            style={{
              padding: '7px 14px',
              borderRadius: 'var(--r-sm)',
              border: 'none',
              cursor: 'pointer',
              fontSize: 12,
              fontWeight: 700,
              background: on ? 'var(--accent-dim)' : 'transparent',
              color: on ? 'var(--accent-soft)' : 'var(--text-muted)',
              whiteSpace: 'nowrap',
            }}
          >
            {label}
          </button>
        );
      })}
    </div>
  );
}
